<template>
  <section class="admin-panel">
    <mdb-container>
      <mdb-row class="title">
        <mdb-col md="12">
          <h1 class="text-left">Profiles</h1>
          <router-link to="/admin/videos/add">
            <mdb-btn v-if="false" color="primary" class="sm m-0 outline" rounded>
              <mdb-icon icon="plus-square" />Add video
            </mdb-btn>
          </router-link>
        </mdb-col>
      </mdb-row>
      <mdb-row>
        <mdb-col md="12">
          <mdb-tbl>
            <thead class>
              <tr>
                <th></th>
                <th>Email</th>
                <th>Nick</th>
                <th>Joined</th>
                <th class="text-center">Edit</th>
                <th class="text-center" v-if="false">Delete</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v,index) in profilesArr" v-bind:key="'tr'+v.id+index">
                <th scope="row">{{v.lp}}</th>
                <td>
                  <strong>{{v.id}}</strong>
                </td>
                <td>
                  <template
                    v-if="v.data.profilePersonalInfo"
                  >{{v.data.profilePersonalInfo.nickname}}</template>
                  <template v-else>no nick in profile</template>
                </td>
                <td>
                  <template v-if="v.data.joinedDate">{{v.data.joinedDate | datetimemomentLLL}}</template>
                  <template v-else>not in profile, shoud not be on production</template>
                </td>
                <td class="narrow text-center" @click="goToEdit(v.id)">
                  <mdb-icon icon="edit round-click sm bg-purple"></mdb-icon>
                </td>
                <td v-if="false" class="narrow text-center" @click="deleteVideo(v.id)">
                  <mdb-icon icon="trash round-click bg-red"></mdb-icon>
                </td>
              </tr>
            </tbody>
          </mdb-tbl>
        </mdb-col>
      </mdb-row>
    </mdb-container>
  </section>
</template>

<script>
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbView,
  mdbCardBody,
  mdbTbl,
  mdbIcon,
  mdbBtn
} from "mdbvue";
import firebase from "firebase/app";
import { store } from "../store";

export default {
  name: "AdminProfiles",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbView,
    mdbCardBody,
    mdbTbl,
    mdbIcon,
    mdbBtn
  },
  created() {
    this.refprofiles.onSnapshot(querySnapshot => {
      console.log("onsnapshot fired");
      this.profilesArr = [];
      var lp = 0;
      querySnapshot.forEach(doc => {
        lp++;
        this.profilesArr.push({
          id: doc.id,
          lp: lp,
          data: doc.data()
        });
      });
    });
  },
  data() {
    return {
      profilesArr: [],
      refprofiles: firebase.firestore().collection("usersProfiles")
    };
  },
  methods: {
    // deleteVideo(id) {
    //   if (confirm("Are you sure?")) {
    //     firebase
    //       .firestore()
    //       .collection("videos")
    //       .doc(id)
    //       .delete();
    //   }
    // },
    goToEdit(profileid) {
      this.$router.replace("/admin/profiles/edit/" + profileid);
    },
    makeRouterLink(videoid) {
      return "admin/videos/edit/" + videoid;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card.card-cascade .view.gradient-card-header {
  padding: 1rem 1rem;
  text-align: center;
}
.card.card-cascade h3,
.card.card-cascade h4 {
  margin-bottom: 0;
}
</style>
